import React from 'react';
import MapPlaceholder from '../components/MapPlaceholder';
import { SITE_CONFIG, NAVER_BLOG_URL } from '../data/siteConfig';
import { Icon } from '../components/icons';

export default function DirectionsPage() {
  return (
    <div>
      <title>오시는길 — KOA DETAILING | 수원 곡반정 세차장</title>
      <meta name="description" content="수원 KOA DETAILING 오시는길: 경기도 수원시 곡반정로 93. 카카오맵·네이버지도·티맵 길찾기 지원. 화-토 10:00-19:00." />
      <link rel="canonical" href="https://koa-asia.com/directions" />

      {/* Page header */}
      <div className="page-header">
        <div className="container">
          <span className="badge badge-primary" style={{ marginBottom: 16 }}>LOCATION</span>
          <h1>오시는 길</h1>
          <p>{SITE_CONFIG.address}</p>
        </div>
      </div>

      {/* Map */}
      <section className="section" style={{ paddingTop: 32 }}>
        <div className="container">
          <MapPlaceholder />

          <div className="gradient-divider" />

          {/* Info cards */}
          <div className="feature-grid">
            <div className="glow-card" style={{
              animation: 'fadeUp 0.6s ease-out 0s both',
            }}>
              <div className="icon-glow" style={{ color: 'var(--primary)' }}>
                <Icon name="Phone" size={28} />
              </div>
              <h4 style={{ textAlign: 'center', marginBottom: 12 }}>전화 문의</h4>
              <a href={`tel:${SITE_CONFIG.phone}`}
                style={{
                  color: 'var(--primary)', display: 'block',
                  textAlign: 'center', fontSize: '1.2rem', fontWeight: 600,
                }}>
                {SITE_CONFIG.phone}
              </a>
              <a href="tel:010-5735-5920"
                style={{
                  color: 'var(--primary)', display: 'block',
                  textAlign: 'center', fontSize: '1.2rem', fontWeight: 600,
                  marginTop: 6,
                }}>
                010-5735-5920
              </a>
            </div>

            <div className="glow-card" style={{
              animation: 'fadeUp 0.6s ease-out 0.1s both',
            }}>
              <div className="icon-glow" style={{ color: 'var(--primary)' }}>
                <Icon name="Clock" size={28} />
              </div>
              <h4 style={{ textAlign: 'center', marginBottom: 12 }}>영업시간</h4>
              <div style={{ textAlign: 'center', color: 'var(--text)', fontSize: '1.1rem', fontWeight: 600 }}>
                {SITE_CONFIG.hours.open}
              </div>
            </div>

            <div className="glow-card" style={{
              animation: 'fadeUp 0.6s ease-out 0.2s both',
            }}>
              <div className="icon-glow" style={{ color: 'var(--primary)' }}>
                <Icon name="MessageSquare" size={28} />
              </div>
              <h4 style={{ textAlign: 'center', marginBottom: 12 }}>채팅 문의</h4>
              <div style={{ textAlign: 'center' }}>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: 12 }}>
                  카카오톡으로 편하게 문의하세요
                </p>
                <a href={`sms:${SITE_CONFIG.phone}`}
                  className="btn btn-outline"
                  style={{ padding: '8px 20px', fontSize: '0.9rem' }}>
                  문자 문의
                </a>
              </div>
            </div>

            <div className="glow-card" style={{
              animation: 'fadeUp 0.6s ease-out 0.3s both',
            }}>
              <div className="icon-glow" style={{ color: 'var(--primary)' }}>
                <Icon name="BookOpen" size={28} />
              </div>
              <h4 style={{ textAlign: 'center', marginBottom: 12 }}>네이버 블로그</h4>
              <div style={{ textAlign: 'center' }}>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: 12 }}>
                  세차 작업 사진과 후기를 확인하세요
                </p>
                <a href={NAVER_BLOG_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline"
                  style={{ padding: '8px 20px', fontSize: '0.9rem' }}>
                  블로그 보러가기
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
